// This is the main Shakapacker entry point for the USOKIE Platform
// It loads Rails dependencies and React on Rails setup

// Tailwind CSS with JIT compiler
import '../stylesheets/application.tailwind.css'

import '@rails/actioncable'
import '@rails/activestorage'

// Feature 007: Turbo Drive for smooth page transitions
import * as Turbo from '@hotwired/turbo'
Turbo.start()

// React on Rails setup
import ReactOnRails from 'react-on-rails'
import HelloWorld from '../bundles/HelloWorld/components/HelloWorld'
import Login from '../bundles/Authentication/components/Login'
import VerifyingToken from '../bundles/Authentication/components/VerifyingToken'

// Rights Graph components
import IpObjectList from '../bundles/RightsGraph/components/IpObjectList'
import IpObjectDetail from '../bundles/RightsGraph/components/IpObjectDetail'
import IpObjectForm from '../bundles/RightsGraph/components/IpObjectForm'
import PartyList from '../bundles/RightsGraph/components/PartyList'
import ContractList from '../bundles/RightsGraph/components/ContractList'

// Party components (Feature 009 design system)
import PartyDetail from '../components/Parties/PartyDetail'
import ContractDetail from '../bundles/RightsGraph/components/ContractDetail'
import ContractForm from '../bundles/RightsGraph/components/ContractForm'
import ImportStatus from '../bundles/RightsGraph/components/ImportStatus'

// Deal Desk components (Feature 009: Deal Operating System)
import DealDeskApp from '../components/DealDesk/DealDeskApp'
import OpportunityCard from '../components/DealDesk/OpportunityCard'
import StatusColumn from '../components/DealDesk/StatusColumn'
import BlockerBadge from '../components/DealDesk/BlockerBadge'
import NewOpportunityModal from '../components/DealDesk/NewOpportunityModal'

// Opportunity components (Feature 009: Deal Operating System)
import DocumentUpload from '../components/Opportunities/DocumentUpload'
import DocumentList from '../components/Opportunities/DocumentList'

// Register components for server rendering and client rendering
ReactOnRails.register({
  HelloWorld,
  Login,
  VerifyingToken,
  IpObjectList,
  IpObjectDetail,
  IpObjectForm,
  PartyList,
  PartyDetail,
  ContractList,
  ContractDetail,
  ContractForm,
  ImportStatus,
  // Deal Desk components (Feature 009)
  DealDeskApp,
  OpportunityCard,
  StatusColumn,
  BlockerBadge,
  NewOpportunityModal,
  // Opportunity components (Feature 009)
  'Opportunities/DocumentUpload': DocumentUpload,
  'Opportunities/DocumentList': DocumentList,
})

console.log('USOKIE Platform loaded successfully')
